import React, {Component} from "react";
import {IReducerState} from "../../../../states/renditionStates";
import {connect} from "react-redux";
import * as asyncStateAction from "../../../../actions/asyncStateAction";
import serviceConfig from "../../../../services/servicesConfig";
import _ from 'lodash';
import $ from "jquery";
import shortid from 'shortid';
import ReactTable from "react-table";
import { enterKeyPressed } from '../../../../utils/general/enterKey';
import 'react-table/react-table.css';
import '../../../../../style/features/keyDataChangeContent.scss';

interface IKeyDataChangeContentVariableProps {
    keyDataChangeData: any;
}

interface IKeyDataChangeContentFunctionalProps {
    loadKeyDataChangeData: (docId: string, docType: string) => {};
}

interface IKeyDataChangeContentProps extends IKeyDataChangeContentVariableProps, IKeyDataChangeContentFunctionalProps {
}

export class KeyDataChangeContent extends Component<IKeyDataChangeContentProps, any> {

    constructor(props: IKeyDataChangeContentProps) {
        super(props);
        this.state = {
            regionMap: {},
            tableData: {},
            selection: [0, 0]
        };
        this.props.loadKeyDataChangeData(window.HTML_RENDITION.doc_id, "KEYDATACHANGES");
    }

    public render() {
        let result = (<div></div>);
        if (!_.isUndefined(this.props.keyDataChangeData)) {
            result = this.renderTable(this.state.regionMap, this.state.tableData, this.state.selection);
        }
        return result;
    }

    public componentWillReceiveProps(nextProps: Readonly<IKeyDataChangeContentProps>, nextContext: any) {
        const keyDataChangeData = nextProps.keyDataChangeData.data;
        if (!_.isUndefined(keyDataChangeData)) {
            const regionMap = keyDataChangeData.regionMap;
            const tableData = keyDataChangeData.tableData;
            if (!_.isUndefined(regionMap) && !_.isUndefined(tableData)) {
                this.setState({
                    regionMap,
                    tableData
                });
                Object.keys(this.state.regionMap).forEach((key: string, index: number) => {
                    if (this.state.regionMap[key] == window.HTML_RENDITION.initialData.regionCode){
                        this.setState({
                        // set the default/initial region index accordion to the regionCode from initialData
                            selection: [index, this.state.selection[1]]
                        });
                    }
                });
            }
        }
    }

    public componentDidMount() {
        this.handleModalResize();
        window.addEventListener('resize', _.throttle(_.bind(this.handleThrottle, this), 200));
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', _.throttle(_.bind(this.handleThrottle, this), 200));
    }

    private handleModalResize() {
        setTimeout(() => {
            const modalBody = $(".modal-body-height");

            const popupDraggableContainer = $(".rendition-modal-window");
            $(popupDraggableContainer).css("visibility", "visible");

            const continentTabHeight = 35;
            const tableTabHeight = 27;
            const footerHeight = 28;
            const modalBodyHeight = $(modalBody).height();
            if (modalBodyHeight) {
                const adjustedBodyHeight = modalBodyHeight - continentTabHeight - tableTabHeight - footerHeight - 10;
                $("#keyDataChangeTabs .ReactTable").css("height", adjustedBodyHeight);
            }
        });
    }

    private handleThrottle() {
        const modalBodyHeight = $(".modal-body-height").height() || 0;
        $(".modal-body-height .ReactTable .rt-tbody").height(modalBodyHeight - 35 - 27 - 28 - 10 - 85);
    }

    private onSelectTableRegion(regionIndex: number) {
        if (this.state.selection[0] != regionIndex) {
            this.setState({
                selection: [regionIndex, this.state.selection[1]]
            });
        }
    }

    private onSelectDataTable(tableIndex: number) {
        if (this.state.selection[1] != tableIndex) {
            this.setState({
                selection: [this.state.selection[0], tableIndex]
            });
        }
    }

    private getArrowClassName(value: string) {
        if (value === "UP") {
            return 'up-arrow';
        } else if (value === "DOWN") {
            return 'down-arrow';
        } else {
            return '';
        }
    }

    private renderTable(regionMap: any, tableData: any, selection: [number, number]) {
        const wTabElements = new Array<JSX.Element>();
        Object.keys(regionMap).forEach((key: string, index: number) => {
            const region = key;
            let optional = "";
            if (selection[0] === index) {
                optional = "focus";
            }
            wTabElements.push(<a tabIndex={0} role="button" aria-label={region} className={"w-tab-link w-tab-link-" + index + " " + "tab-link" + " " + optional}
                                 onClick={() => this.onSelectTableRegion(index)} key={shortid.generate()}
                                 onKeyPress={(e) => enterKeyPressed(e, this.onSelectTableRegion.bind(this, index))}
                              ><span className="w-tab-title">{region}</span></a>);
        });
        const wTabContainer = (<div className={"w-tab-bar"}>
            <div className={"w-tab-bar-body"}>
                <div className={"w-tab-bar-container"}>
                    <div className={"w-tab-bar-container-wrapper tabs"}>
                        {wTabElements}
                    </div>
                </div>
            </div>
            <div className={"w-tab-bar-strip"}/>
        </div>);
        const wTabBodyContainer = new Array<JSX.Element>();
        Object.keys(regionMap).forEach((key: string, regionIndex: number) => {
            if (regionIndex == selection[0]) {
                const table = tableData[key];
                const wTabBarContainer = new Array<JSX.Element>();
                for (let i = 0; i < table.length; i++) {
                    let optional = "";
                    if (i === selection[1]) {
                        optional = "active";
                    }
                    wTabBarContainer.push(<a className={"w-tab-link w-tab-link-" + i + " " + optional}
                                             role="button" tabIndex={0} aria-label={table[i].name}
                                             onClick={() => this.onSelectDataTable(i)} key={shortid.generate()}
                                             onKeyPress={(e) => enterKeyPressed(e, this.onSelectDataTable.bind(this, i))}
                                          ><span className="w-tab-title">{table[i].name}</span></a>);
                }
                const wTabBodyContentContainer = new Array<JSX.Element>();
                const currentTable = table[selection[1]];
                const columns = currentTable.columns;
                const tableColumn = new Array<any>();
                const tableColumnIndex = new Array<string>();
                columns.forEach((column: any) => {
                    if (!_.isUndefined(column.columns)) {
                        const childColumns = new Array<any>();
                        column.columns.forEach((child: any) => {
                            childColumns.push({
                                Header: child.text,
                                accessor: child.dataIndex,
                                headerClassName: 'row2',
                                width: 100,
                                maxWidth: 150,
                                getProps: (state: any, rowInfo: any, col: any) => {
                                    const value = rowInfo.row[col.id];
                                    const isNumeric = !isNaN(parseInt(value, 10));
                                    const numberFieldBln = (col.id === 'TargetPriceCurr' || col.id === 'TargetPricePrev'                         || col.id == 'CurrYearEPSEstCurr' || col.id == 'CurrYearEPSEstPrev'
                                    || col.id === 'CurrYearEPSEstCurr' || col.id === 'CurrYearEPSEstPrev'
                                    || col.id === 'NextYearEPSEstCurr' || col.id === 'NextYearEPSEstPrev'
                                    || col.id === 'ClosingPrice');
                                    if (child.dataIndex === "RatingTargetPrice" || child.dataIndex === 'EstChangeCurr' || child.dataIndex === 'EstChangeNextYear') {
                                        rowInfo.row[col.id] = '';
                                    }
                                    return {
                                        style: {
                                            textAlign: (numberFieldBln || isNumeric) ? "right" : "initial"
                                        },
                                        className: this.getArrowClassName(value.toUpperCase())
                                    };
                                }
                            });
                            tableColumnIndex.push(child.dataIndex);
                        });
                        tableColumn.push({
                            Header: column.text,
                            headerClassName: 'row1',
                            columns: childColumns
                        });
                    } else {
                        if (column.dataIndex === "Company") {
                            tableColumn.push({
                                Header: column.text,
                                accessor: column.dataIndex,
                                headerClassName: 'row2',
                                width: 190,
                                maxWidth: 190
                            });
                            tableColumnIndex.push(column.dataIndex);
                        } else if (column.dataIndex === "RatingTargetPrice" || column.dataIndex === 'EstChangeCurr' || column.dataIndex === 'EstChangeNextYear') {
                            tableColumn.push({
                                Header: column.text,
                                accessor: column.dataIndex,
                                headerClassName: 'row2',
                                width: 200,
                                maxWidth: 200,
                                getProps: (state: any, rowInfo: any, col: any) => {
                                    const value = rowInfo.row[col.id];
                                    rowInfo.row[col.id] = "";
                                    return {
                                        className: this.getArrowClassName(value.toUpperCase())
                                    };
                                }
                            });
                        } else if (column.dataIndex === "Ccy") {
                            tableColumn.push({
                                Header: column.text,
                                accessor: column.dataIndex,
                                headerClassName: 'row2',
                                width: 60,
                                maxWidth: 60,
                            });
                        } else {
                            tableColumn.push({
                                Header: column.text,
                                accessor: column.dataIndex,
                                headerClassName: 'row2',
                                width: 100,
                                maxWidth: 150,
                            });
                        }
                        tableColumnIndex.push(column.dataIndex);
                    }
                });
                const tableRow = new Array<any>();
                const rows = currentTable.rows;
                const pageSize = rows.length;
                for (let j = 0; j < rows.length; j++) {
                    const datum: any = {};
                    const cells = rows[j].cells;
                    tableColumnIndex.forEach((index: any) => {
                        datum[index] = (cells[index]).value;
                    });
                    tableRow.push(datum);
                }
                const footerNotes = new Array<any>();
                for (let j = 0; j < currentTable.footers.length; j++) {
                    const footer = currentTable.footers[j];
                    footerNotes.push(<div className="footer-row" dangerouslySetInnerHTML={{__html: footer.text}} key={shortid.generate()}/>);
                }
                wTabBodyContentContainer.push(
                <div className={"w-tab-body-content w-tab-body-content" + " " + "active"} key={shortid.generate()}>
                    <div className={"tab-content-holder"}>
                        <div className={"w-grid w-border-box w-grey-theme"}>
                            <div className={"w-grid-view"}>
                                <ReactTable
                                    className='dataTable'
                                    columns={tableColumn}
                                    data={tableRow}
                                    showPagination={false}
                                    pageSize={pageSize}
                                    sortable={false}
                                    getTbodyProps={() => {
                                        const modalBody = $(".modal-body-height");
                                        const modalBodyHeight = $(modalBody).height();
                                        let adjustedBodyHeight = 425;
                                        if (modalBodyHeight) {
                                            adjustedBodyHeight = modalBodyHeight - 35 - 27 - 28 - 10 - 85;
                                        }
                                        return{
                                            style:{ height: adjustedBodyHeight }
                                        };
                                     }}
                                    />
                            </div>
                            <div className="footer-container">
                                <div className="footer-sub-container">
                                    {footerNotes}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>);
                wTabBodyContainer.push(
                <div className={"w-tab-body-content w-tab-body-content-" + wTabBodyContainer.length} key={shortid.generate()}>
                    <div className={"tab-content-holder"} id={"tab_region_" + wTabBodyContainer.length}>
                        <div className={"w-tab lvl2"}>
                            <div className={"w-tab-bar"}>
                                <div className={"w-tab-bar-body"}>
                                    <div className={"w-tab-bar-container"}>
                                        <div className={"w-tab-bar-container-wrapper"}>
                                            {wTabBarContainer}
                                        </div>
                                    </div>
                                </div>
                                <div className={"w-tab-bar-strip"}/>
                            </div>
                            <div className={"w-tab-body"}>
                                {wTabBodyContentContainer}
                            </div>
                        </div>
                    </div>
                </div>);
            }
        });
        return (<div id="keyDataChangeTabs" tabIndex={0}>
            <div className="w-tab lv11">
                {wTabContainer}
                <div className="w-tab-body">
                    {wTabBodyContainer}
                </div>
            </div>
        </div>);
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        keyDataChangeData: state.asyncStateReducer.keyDataChangeData
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loadKeyDataChangeData: (docId: string, docType: string) =>
            dispatch(asyncStateAction.fetchKeyDataChangeData(serviceConfig.GET_KEY_DATA_CHANGE, docId, docType)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KeyDataChangeContent);
